module.exports = __webpack_public_path__ + "img/CustomizableChannels.dac8fbd4.png";